module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-18.df2b76f7.png";